export default "__VITE_ASSET__104b5aa8__"